//#region src/assets.ts
const productVisuals = [
	{
		id: "hero",
		source: "hamnivo-hero.png",
		width: 1536,
		height: 1024,
		background: "dark",
		caption: {
			en: "Connected conversations",
			ar: "محادثات متصلة",
			hi: "जुड़ी हुई बातचीत",
			ur: "جڑی ہوئی گفتگو"
		},
		alt: {
			en: "A chat window between a customer card and the Hamnivo mark, joined by a flowing ink and coral ribbon.",
			ar: "نافذة محادثة بين بطاقة عميل وشعار Hamnivo، يربط بينها شريط متدفق باللونين الداكن والمرجاني.",
			hi: "ग्राहक कार्ड और Hamnivo चिह्न के बीच एक चैट विंडो, जिन्हें गहरे और कोरल रंग का बहता हुआ रिबन जोड़ता है।",
			ur: "کسٹمر کارڈ اور Hamnivo نشان کے درمیان ایک چیٹ ونڈو، جنہیں گہرے اور مرجانی رنگ کا بہتا ہوا ربن جوڑتا ہے۔"
		},
		reviewStatus: "pending_native_review"
	},
	{
		id: "teamwork",
		source: "hamnivo-teamwork.png",
		width: 1254,
		height: 1254,
		background: "transparent",
		caption: {
			en: "Coordinated participants",
			ar: "مشاركون منسّقون",
			hi: "तालमेल वाले प्रतिभागी",
			ur: "ہم آہنگ شرکاء"
		},
		alt: {
			en: "A person's card with an approved reply in the centre, flanked by two Hamnivo AI panels on a shared coral ring.",
			ar: "بطاقة شخص في المنتصف مع رد معتمد، وعلى جانبيها لوحتان للذكاء الاصطناعي من Hamnivo على حلقة مرجانية مشتركة.",
			hi: "बीच में स्वीकृत जवाब के साथ एक व्यक्ति का कार्ड, जिसके दोनों ओर साझा कोरल घेरे पर Hamnivo AI के दो पैनल हैं।",
			ur: "درمیان میں منظور شدہ جواب کے ساتھ ایک شخص کا کارڈ، جس کے دونوں طرف مشترکہ مرجانی دائرے پر Hamnivo AI کے دو پینل ہیں۔"
		},
		reviewStatus: "pending_native_review"
	},
	{
		id: "memory",
		source: "hamnivo-memory.png",
		width: 1254,
		height: 1254,
		background: "transparent",
		caption: {
			en: "Context and correction",
			ar: "السياق والتصحيح",
			hi: "संदर्भ और सुधार",
			ur: "سیاق اور تصحیح"
		},
		alt: {
			en: "An archive tray of document cards linked by a coral timeline; one card is being updated and the last one is verified.",
			ar: "درج أرشيف لبطاقات مستندات يربطها خط زمني مرجاني؛ إحدى البطاقات قيد التحديث والأخيرة موثّقة.",
			hi: "दस्तावेज़ कार्डों की एक संग्रह ट्रे जिन्हें कोरल समयरेखा जोड़ती है; एक कार्ड अपडेट हो रहा है और आख़िरी कार्ड सत्यापित है।",
			ur: "دستاویزی کارڈز کی ایک آرکائیو ٹرے جنہیں مرجانی ٹائم لائن جوڑتی ہے؛ ایک کارڈ اپ ڈیٹ ہو رہا ہے اور آخری کارڈ تصدیق شدہ ہے۔"
		},
		reviewStatus: "pending_native_review"
	},
	{
		id: "integrations",
		source: "hamnivo-integrations.png",
		width: 1254,
		height: 1254,
		background: "transparent",
		caption: {
			en: "Connected applications",
			ar: "تطبيقات متصلة",
			hi: "जुड़े हुए ऐप्लिकेशन",
			ur: "جڑی ہوئی ایپلیکیشنز"
		},
		alt: {
			en: "A central Hamnivo hub connected by coral cables to a website, a mobile app, an API code block and a server.",
			ar: "مركز Hamnivo متصل بكابلات مرجانية بموقع ويب وتطبيق جوال وكتلة شيفرة لواجهة برمجة التطبيقات وخادم.",
			hi: "एक केंद्रीय Hamnivo हब, जो कोरल केबलों से एक वेबसाइट, मोबाइल ऐप, API कोड ब्लॉक और सर्वर से जुड़ा है।",
			ur: "ایک مرکزی Hamnivo حب جو مرجانی کیبلز کے ذریعے ویب سائٹ، موبائل ایپ، API کوڈ بلاک اور سرور سے جڑا ہے۔"
		},
		reviewStatus: "pending_native_review"
	},
	{
		id: "multilingual",
		source: "hamnivo-multilingual.png",
		width: 1254,
		height: 1254,
		background: "transparent",
		caption: {
			en: "English, Hindi, Arabic and Urdu",
			ar: "الإنجليزية والهندية والعربية والأردية",
			hi: "अंग्रेज़ी, हिंदी, अरबी और उर्दू",
			ur: "انگریزی، ہندی، عربی اور اردو"
		},
		alt: {
			en: "Four speech bubbles saying Hello, Marhaba, Namaste and Salam around the Hamnivo hub, joined by a coral ring.",
			ar: "أربع فقاعات حوار بالتحيات Hello ومرحبا ونमस्ते وسلام حول مركز Hamnivo، تربطها حلقة مرجانية.",
			hi: "Hamnivo हब के चारों ओर चार संवाद-बुलबुले — Hello, मरहबा, नमस्ते और सलाम — जिन्हें कोरल घेरा जोड़ता है।",
			ur: "Hamnivo حب کے گرد چار مکالماتی غبارے — Hello، مرحبا، نمستے اور سلام — جنہیں مرجانی دائرہ جوڑتا ہے۔"
		},
		reviewStatus: "pending_native_review"
	},
	{
		id: "commerce",
		source: "hamnivo-commerce.png",
		width: 1254,
		height: 1254,
		background: "transparent",
		caption: {
			en: "Review before confirmation",
			ar: "المراجعة قبل التأكيد",
			hi: "पुष्टि से पहले समीक्षा",
			ur: "تصدیق سے پہلے جائزہ"
		},
		alt: {
			en: "An order summary card, a coral 'next' step, a wrapped parcel and a phone showing an approval check mark.",
			ar: "بطاقة ملخص طلب، وخطوة تالية باللون المرجاني، وطرد مغلّف، وهاتف يعرض علامة موافقة.",
			hi: "ऑर्डर सारांश कार्ड, कोरल रंग का 'अगला' चरण, एक पैक किया हुआ पार्सल और स्वीकृति का निशान दिखाता फ़ोन।",
			ur: "آرڈر خلاصہ کارڈ، مرجانی 'اگلا' مرحلہ، ایک پیک شدہ پارسل اور منظوری کا نشان دکھاتا فون۔"
		},
		reviewStatus: "pending_native_review"
	}
];
/** Vector brand assets generated by scripts/vectorize.ts and scripts/icons.ts (in assets/). */
const brandAssets = {
	mark: "hamnivo-mark.svg",
	markOnDark: "hamnivo-mark-on-dark.svg",
	markMono: "hamnivo-mark-mono.svg",
	lockup: "hamnivo-lockup.svg",
	lockupOnDark: "hamnivo-lockup-on-dark.svg",
	wordmark: "hamnivo-wordmark.svg",
	favicon: "favicon.svg",
	faviconIco: "favicon.ico",
	appleTouchIcon: "apple-touch-icon.png",
	icon192: "icon-192.png",
	icon512: "icon-512.png",
	maskable512: "icon-maskable-512.png",
	ogImage: "og-image.png",
	manifest: "site.webmanifest"
};
//#endregion
//#region src/contrast.ts
const HEX = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i;
function parseHex(hex) {
	const match = HEX.exec(hex.trim());
	if (!match?.[1]) throw new TypeError(`Invalid hex colour: ${hex}`);
	const digits = match[1].length === 3 ? [...match[1]].map((d) => d + d).join("") : match[1];
	return {
		r: Number.parseInt(digits.slice(0, 2), 16),
		g: Number.parseInt(digits.slice(2, 4), 16),
		b: Number.parseInt(digits.slice(4, 6), 16)
	};
}
function isHexColor(value) {
	return HEX.test(value.trim());
}
function channel(value) {
	const c = value / 255;
	return c <= .04045 ? c / 12.92 : ((c + .055) / 1.055) ** 2.4;
}
/** Relative luminance per WCAG 2.x. */
function relativeLuminance(color) {
	const { r, g, b } = typeof color === "string" ? parseHex(color) : color;
	return .2126 * channel(r) + .7152 * channel(g) + .0722 * channel(b);
}
/** Contrast ratio between two opaque colours, from 1 to 21. */
function contrastRatio(a, b) {
	const la = relativeLuminance(a);
	const lb = relativeLuminance(b);
	const [hi, lo] = la >= lb ? [la, lb] : [lb, la];
	return (hi + .05) / (lo + .05);
}
/** Rounds down so a reported "4.49" never displays as passing 4.5. */
function formatRatio(ratio) {
	return `${(Math.floor(ratio * 100) / 100).toFixed(2)}:1`;
}
/** WCAG 2.2 AA thresholds: 4.5:1 body text, 3:1 large text and UI components/graphics. */
const AA_THRESHOLD = {
	text: 4.5,
	"large-text": 3,
	ui: 3
};
function meetsAA(foreground, background, use) {
	return contrastRatio(foreground, background) >= AA_THRESHOLD[use];
}
/**
* Validates a tenant theme. Every pair that carries text must reach 4.5:1; the accent must be
* distinguishable from the surface as a UI component (3:1). Returns the failing pairs with a
* plain-language message the widget studio shows next to the offending field.
*/
function validateTheme(theme) {
	for (const [field, value] of Object.entries(theme)) if (!isHexColor(value)) return [{
		field,
		pair: [value, value],
		ratio: 0,
		required: 0,
		use: "ui",
		message: `${field} must be a hex colour such as #192A30`
	}];
	const checks = [
		{
			field: "onAccent",
			fg: theme.onAccent,
			bg: theme.accent,
			use: "text",
			what: "Button text"
		},
		{
			field: "text",
			fg: theme.text,
			bg: theme.surface,
			use: "text",
			what: "Body text"
		},
		{
			field: "accent",
			fg: theme.accent,
			bg: theme.surface,
			use: "ui",
			what: "Accent"
		}
	];
	const issues = [];
	for (const check of checks) {
		const ratio = contrastRatio(check.fg, check.bg);
		const required = AA_THRESHOLD[check.use];
		if (ratio < required) issues.push({
			field: check.field,
			pair: [check.fg, check.bg],
			ratio,
			required,
			use: check.use,
			message: `${check.what} contrast is ${formatRatio(ratio)}; at least ${required}:1 is required.`
		});
	}
	return issues;
}
/** Picks whichever of the candidates gives the highest contrast on the background. */
function bestOn(background, candidates) {
	let best = candidates[0];
	let bestRatio = -1;
	for (const candidate of candidates) {
		const ratio = contrastRatio(candidate, background);
		if (ratio > bestRatio) {
			best = candidate;
			bestRatio = ratio;
		}
	}
	if (!best) throw new RangeError("bestOn needs at least one candidate");
	return best;
}
//#endregion
//#region src/generated/mark.ts
const markGeometry = {
	viewBox: "716 690 3667 3687",
	ink: "M4212 954.1c-2.5.6-9.4 1.6-15.5 2.4s-14.4 2-18.5 2.8a1176 1176 0 0 1-37 6.8l-9.5 2a535 535 0 0 0-59 15.1c-7.4 2.1-20.1 6.3-23.8 7.8l-8.7 2.8-15.5 4.7a337 337 0 0 0-46 16.9c-1.6.9-3.6 1.6-4.2 1.6s-3.4 1-6 2.1c-8.8 4-12.8 5.6-18.3 7.7l-12.5 4.8a270 270 0 0 0-17 7.4c-14 6.7-25.9 12.2-33.5 15.6a1129 1129 0 0 0-31.5 15.5l-52.5 26.4c-4.7 2.3-16.5 8.8-26.3 14.4l-18.2 10.1c-1 0-23.1 13.1-30.7 18.1a78 78 0 0 1-11.7 7.3c-.9.8-4.3 2.8-7.6 4.5a158 158 0 0 0-10 5.6l-10.4 6.1c-3.6 2-11.2 6.9-17 10.8s-14.2 9.3-18.6 12c-8.7 5.4-43.7 28.7-55 36.6-17 12-54.5 39.9-61.4 45.9-3.1 2.6-11.2 9-18.1 14.1a680 680 0 0 0-54 45l-8.5 7.5c-31 27-44.8 40.6-75.5 74.5l-11 12a241 241 0 0 0-26.2 34 614 614 0 0 0-95.3 171 855 855 0 0 0-10.5 30.5l-3.5 12c-6.8 22.4-8.4 29-12.6 52-1 6-2.3 12.5-2.8 14.5-.6 1.9-1.2 6.2-1.6 9.5-.3 3.3-1.2 10.3-2 15.5s-1.7 14.4-2 20.5a401 401 0 0 1-2.1 23c-1.2 10.3-1.5 59.6-1.7 343.5-.2 182.3-.1 332.4.1 333.6s2 2.9 4.5 4.1l17.9 8.9a162 162 0 0 0 22.2 10.4 336 336 0 0 1 38.1 18.5c8.3 4.3 16.8 8.9 19 10.3s8 4.6 13 7.2c8 4.2 13.3 7.2 29.3 16.7l6.7 3.8a218 218 0 0 1 13.5 7.8c1.4.7 6.1 3.6 10.5 6.4a1034 1034 0 0 0 41.5 26.3l9.5 6a525 525 0 0 1 39 26l12 8.4c8.7 5.9 20 14.3 26.1 19.3l16.4 13.1c6.9 5.5 14.1 11.4 16 13.2s6.9 5.7 11 8.8a612 612 0 0 1 59 50.8c36.3 35.4 49.5 48.8 60 61.4a728 728 0 0 0 28.1 31.9l7.6 9.1 9.3 11c1.7 1.9 9 11.3 16.1 20.7a451 451 0 0 0 17.4 22.1l9.9 14.2a1025 1025 0 0 1 56.3 88.2c2.6 3.3 26 48.4 34.1 65.8 7 14.9 10.5 22.7 11.7 26l5.9 14c4.4 9.9 15.5 37.5 19.5 48.5 2.8 7.7 13.7 41.2 16 49 1.1 3.8 2.7 9.5 3.7 12.5a886 886 0 0 1 30.4 167.5l2 23.2a1447 1447 0 0 1 .3 96.1q-.6 11.1-1.7 10.9c-1.4-.4-3.8-8.4-6.6-21.7a764 764 0 0 0-16.3-64l-5.2-16.5a486 486 0 0 0-18.3-48.6 1055 1055 0 0 0-54.5-106.9l-3.8-6.5-3.5-6c-.9-1.7-5.2-8.2-9.4-14.7-6.8-10.2-13-18.7-29.4-40.8-2.3-3-5.4-7.5-7.1-10a244 244 0 0 0-22.9-28 550 550 0 0 1-14.1-15.6 617 617 0 0 0-55-57.4 546 546 0 0 1-17.5-16.4 396 396 0 0 0-52.1-43.6c-5-3.6-13.7-10.5-19.3-15.3a489 489 0 0 0-36.6-28.4 2386 2386 0 0 0-96.6-62.9 1257 1257 0 0 0-97.5-52.3 1307 1307 0 0 0-69.4-32.6c-1.6-.8-7-3-12-5.1l-17-7.2c-20.4-8.9-57.9-23.3-82-31.7l-22-8c-6.6-2.6-13.8-5.2-16-6l-11-4c-3.8-1.4-8.6-3-10.5-3.5-4.8-1.1-25.4-6.6-31.5-8.4-2.7-.8-8.1-2.6-12-4.1l-13.5-4.6c-6.4-2-8.4-2.6-24.5-6.9l-15.5-4.1a883 883 0 0 0-30-7.8c-4.2-1-8.5-2.3-9.5-2.8-1.1-.6-4-1.3-6.4-1.7s-5.6-1.3-7.2-2.1c-1.5-.8-3.7-1.5-4.8-1.5a50 50 0 0 1-8.3-1.9 681 681 0 0 0-49.8-12.2l-17.5-3.9c-15.1-3.4-43.8-9.5-51-10.8-5-1-8.6-1.8-22.5-5.2-12.2-3-26.1-5.9-32-6.6-3-.4-6.6-1.1-7.9-1.6s-5.5-1.3-9.5-1.8c-3.9-.6-9.8-1.6-13.1-2.4a353 353 0 0 0-33.5-6.1 634 634 0 0 1-36.5-6l-17.5-3-18-3.1c-26-4.8-97.2-14.9-112-15.9a136 136 0 0 1-15.5-2c-3.8-.8-10.4-1.7-14.5-2s-10.6-1.2-14.5-2c-3.8-.7-10.6-1.6-15-2s-10.7-1.2-14-2c-3.3-.7-9.1-1.6-13-1.9-3.8-.4-9.7-1.3-13-2.1-8.3-2-22.8-4.3-36.6-5.9-6.3-.8-13.3-1.9-15.5-2.4s-6.4-1.3-9.4-1.7-6.9-1.1-8.6-1.6a465 465 0 0 0-34.4-6.3 1094 1094 0 0 1-49.9-10.7 57 57 0 0 0-10.2-1.9c-1.5 0-4-.5-5.6-1.1a70 70 0 0 0-9.3-2.4c-7.2-1.6-16-3.8-23.5-6-5.6-1.7-15.3-4.1-23.5-5.9l-9-2.4c-3.7-1.2-12.3-3.5-20-5.3l-16.5-4.6c-6.6-2-13.3-3.9-15-4.3-4.6-1.1-26.5-8-30.5-9.6-1.9-.7-5.3-1.8-7.5-2.3-3.8-.9-10.2-2.9-17-5.2l-12.5-4.1-14.2-4.9a25 25 0 0 0-6.3-1.9c-.9 0-2.9-.6-4.3-1.4-1.5-.8-6.1-2.6-10.2-4.2a62 62 0 0 1-8.6-3.6c-1-.7-4.8-2.1-16.9-6.3a687 687 0 0 1-54.5-21.3l-10.2-4.6a36 36 0 0 0-7-2.6 7 7 0 0 1-3.3-1.4c-1.1-.7-3.1-1.7-4.5-2.1-2.8-.8-7.9-3-19.7-8.6a83 83 0 0 0-8.6-3.9c-.3 0-4.5-1.8-9.4-4.1l-13.3-6.1c-9-4.1-37.6-18.3-42.4-21.1-2.8-1.6-12.9-6.9-22.5-11.9-15-7.7-26.7-14-33.1-17.8l-11.4-6.7a1008 1008 0 0 1-39.9-24.5c-5.4-3.5-7.6-4.8-12.3-7.6q-6.5-3.7-22.5-14.8l-22.9-15.5c-8.5-5.8-22-15.4-30-21.5a617 617 0 0 0-25-17.9 345 345 0 0 1-38-30.5 555 555 0 0 0-22-18.3 613 613 0 0 1-60-54.2l-23.4-22.6a294 294 0 0 1-15.5-16.4l-24.7-28a1166 1166 0 0 1-56.9-70.6c-7.9-10.7-33.4-48.4-40.6-60.1a2804 2804 0 0 1-41.1-72.5 825 825 0 0 1-50.2-115.3c-2.4-6.9-5.7-15.7-7.1-19.5a879 879 0 0 1-21-66.1c-5-16.6-17.7-71.9-20.4-88.7l-4.1-25a1238 1238 0 0 1-9.5-77.7l-2.5-23.5c-2.3-20.4-3.4-60.8-3.2-111 .3-51.1 1.1-71.6 3.1-75.4 1.1-1.9 1.7-68.8.7-69.8a91 91 0 0 0-13.8 8.9l-27.3 19.1c-30 20.8-50.1 35.5-70 51.2l-18 14a336 336 0 0 0-18.5 15.6l-9.8 8.2a988 988 0 0 0-67.1 64.2 532 532 0 0 0-51.3 65.5l-5.5 8a205 205 0 0 0-13.6 22.5c-3.9 6.7-7.5 13.7-10 19.5l-5.4 12a530 530 0 0 0-17.8 42.5A538 538 0 0 0 855 1733c-2.1 24.5-2.1 24.9-1.8 1185l.3 1160.5 2.5-.1c1.4-.1 4.1-.7 6-1.4l9-3.3 9.6-3.8c2.3-1.1 4.6-1.9 5.1-1.9a549 549 0 0 0 21.3-8.9c2.5-1.1 8.8-3.7 14-5.6a1051 1051 0 0 0 38.5-15.9 584 584 0 0 1 36-16.1l22.5-9.5c1.4-.6 7.9-3.9 14.5-7.5a468 468 0 0 1 26.5-13.6l4-2.1 10.5-4.9 9.5-4.4 41-21.2a641 641 0 0 0 35.5-19.7c7.7-4.7 20.3-11.8 28-15.7a526 526 0 0 0 36.5-20.4l21.5-13c9.9-5.8 24.5-14.7 32.5-19.6l26-15.9 22.7-14c6.2-3.8 16.6-10.6 23-15.2 6.5-4.6 19.9-13.7 29.8-20.2a488 488 0 0 0 41.9-29c2.3-1.8 7.7-5.8 12.1-8.8a720 720 0 0 0 26.5-18.5l26-19.5c36.4-27.3 52.4-39.5 55-41.8l13-10.8c5.8-4.8 10.7-8.9 11-9.3l14-10.7c7.4-5.6 15.8-12.2 18.5-14.8a3465 3465 0 0 1 60.4-53.9l9-8q11.8-10.4 25.1-23.2c5.2-5 13.9-12.8 19.3-17.3a373 373 0 0 0 18.5-16.8c4.7-4.7 12-11.7 16.2-15.6a3080 3080 0 0 0 67-63.8l15.5-14.7c5.5-5.3 13.6-12.8 17.9-16.6 4.4-3.9 12.3-11.3 17.6-16.5a1555 1555 0 0 1 54.5-50.5l14.9-13.8a516 516 0 0 1 24.6-21c9.6-7.7 18.9-15.3 20.5-16.8a815 815 0 0 1 52.9-42.7l26.1-20.2c9.5-7.4 21.6-16.4 26.9-20s16.7-11.7 25.5-18.1a830 830 0 0 1 64.1-44c4.1-2.3 10.4-6.3 14-8.8 13.3-9.2 25-16.8 36.5-23.6 4.4-2.7 13.2-8.2 19.5-12.3s21-12.9 32.5-19.4a773 773 0 0 0 26.5-15.1l5.5-3.1 8.1-5.2c2.8-1.8 10.7-6.2 17.5-9.7l17.9-9.4 15.5-8.3 16.5-9c3.6-2.1 16.4-8.7 28.5-14.7l34.5-17.5c6.9-3.6 17.2-8.7 23-11.3 14.2-6.4 18.9-8.6 31.1-14.3 17-8.1 23.8-11.2 24.3-11.2.3 0 6.1-2.4 12.8-5.4l22.3-9.5 12-5.1c13.5-5.8 34.1-14 35.4-14 1.5 0 17.7-6.5 31.6-12.5a415 415 0 0 1 30.5-11.6l31-10.5c14-4.8 15.4-5.2 41-12.7l20.5-6.2c24.2-7.7 75.5-20.9 97.5-25 8-1.4 21.3-4 29.5-5.6 70.2-13.7 175.2-12.3 231.5 3.1 44.6 12.2 73 24.2 101 42.7a238 238 0 0 1 45.6 37.8 156 156 0 0 1 27.6 33.5c20.6 31 27.8 49 34.4 86 5.9 32.9 5.9 31.8 5.5 751.2-.1 245.7 0 447.2.4 447.8.8 1.3 18.3 1.3 25.6 0 3-.5 11.5-1.6 18.9-2.5 11.9-1.3 22.2-2.9 41-6.4l21-3.7a316 316 0 0 0 42-9.6c6.3-1.7 14.4-3.6 18-4.3 12.4-2.6 26.7-6.5 38.6-10.5l15.4-5c7.6-2 34.9-11.3 45.4-15.5a315 315 0 0 1 30.1-10.9c6.8-2.9 14.1-5.6 15-5.6.5 0 2.7-.9 4.9-1.9 9.7-4.5 20.7-9.6 28.6-13.1 15.6-6.9 36.2-16.5 49-23 39-19.6 54.6-27.7 59.2-30.7 2.9-2 6.2-4 7.3-4.5l5.7-3.1 21.3-12.7 9.7-6.3a2071 2071 0 0 0 58.8-38.9c14-10.2 28.4-21.3 34.4-26.7 3.8-3.3 11.2-9.3 16.5-13.3a305 305 0 0 0 18.6-14.6l10-8.2c18.8-16.8 66.8-64.7 76.6-76.4l27.7-33.2 15.2-18.1a902 902 0 0 0 68-105.3c1.7-2.8 11.8-23.5 15.4-31.5l4.6-9.6c.5-.9 2.3-5.4 4.1-10a348 348 0 0 1 9.9-23.4c0-.5.8-2.7 1.9-4.9l4.6-11.6c1.5-4.1 3.1-8.3 3.6-9.2.5-1 2.3-6.1 4-11.5l4.4-13.8c.7-2.2 1.6-5.6 2-7.5s1.5-6.2 2.5-9.5a1054 1054 0 0 0 15.5-58.5c.7-3 1.7-7.8 2-10.5s1.1-6.8 1.7-9a890 890 0 0 0 9.9-81.5c.7-9.6 1.1-51 1-123-.3-186-2-630.2-3.1-794-.6-86.1-1.5-308.6-2.1-494.5-.5-185.9-1.4-396.1-1.9-467-.5-71-1.1-231.2-1.4-356-.4-124.9-.9-230.6-1.2-235-.4-4.4-1.1-8.6-1.6-9.3-1.2-1.4-14.8-1.5-21.8-.1",
	coral: "m1906.5 831-10 5.5a479 479 0 0 0-41.9 23.5c-.4 0-5.7 2.8-11.9 6.3l-18.2 10.2-7 4.1-6.6 3.7-58.2 33.7c-8.6 4.9-12.1 7-17.9 10.7a203 203 0 0 1-11.5 7l-9.1 5.5c-1.5.9-5.4 3.1-8.7 4.8a75 75 0 0 0-7.5 4.4 213 213 0 0 0-22.5 13.8 649 649 0 0 1-32.9 20.7l-20 11.6-11.1 6.5c-10 5.9-10.8 6.3-19 11.5-3.8 2.4-14 8.4-22.5 13.3a690 690 0 0 0-28.2 17.3 667 667 0 0 1-30.3 19.4 967 967 0 0 1-28.9 18c-1.7 1.2-9.2 5.7-16.6 10.2s-19.2 11.9-26.2 16.5a1119 1119 0 0 1-37.3 23.6c-3.9 2.2-10.5 6.5-14.8 9.6-4.2 3-11 7.4-14.9 9.7-8.1 4.7-14.7 8.8-37.3 23.4l-23.6 15c-4.4 2.7-12.8 8.4-18.6 12.5a786 786 0 0 1-23.4 15.7 393 393 0 0 0-19.6 13 935 935 0 0 1-24.5 16.6l-17.6 11.8-.1 35c-.1 28.6.1 35.7 1.3 39.3.9 2.5 2.3 11.8 3.1 20.8 2.9 29.3 7.3 53.4 16.5 90.8a648 648 0 0 0 23.9 78.5l7 19.8c2.9 8.1 7.2 19.2 9.7 24.5l10.9 23.8a973 973 0 0 0 58 109.4l8.4 14a751 751 0 0 0 32.6 49.5l8.3 11.6c2.8 4.1 15.4 20.3 36.7 47.2 39.5 49.8 75.3 88.5 126 136.2a579 579 0 0 0 37 33.6c4.4 3.5 11.4 9.3 15.6 12.9 12 10.3 22.3 18.9 33.8 27.8 9 7 19 14.6 58.6 44.3 5.9 4.4 12.2 8.8 35.2 24.6a661 661 0 0 0 43.3 27.9l20.5 12.4c3.3 2.1 14.9 8.9 25.9 15.1l23.5 13.6c3.2 2 15.9 8.3 60 29.9a84 84 0 0 0 15.8 6.7c.7-.3 1.7-1.7 2.1-3.2 1.3-4.7-.3-1335.5-1.6-1364.6l-.7-14-3-.2c-1.9-.1-5.7 1.3-10 3.7"
};
//#endregion
//#region src/tokens.ts
/**
* Hamnivo design tokens. Source: docs/design/Design-System.md (ink–ivory–coral).
* `assets/tokens.css` and `assets/theme.css` are generated from this file (scripts/css.ts);
* tests verify every text and UI colour pair used by the semantic tokens meets WCAG 2.2 AA.
*/
/** Core palette from the design kit. */
const palette = {
	ink: "#192A30",
	ivory: "#F6F3EC",
	white: "#FFFFFF",
	/** Active indicator, selection edges, decoration. Never small text (3.80:1 on white). */
	coral: "#E45136",
	/** Text-bearing coral fills (badges, tenant-accent buttons): 5.2:1 with white text. */
	coralStrong: "#C2411F",
	/** Links and errors with text/icons. */
	rust: "#A22F20",
	/** Success foreground on a light surface. */
	sage: "#26724B",
	/** Caution foreground on a light surface. */
	amber: "#855B12"
};
const colors = {
	light: {
		bg: palette.ivory,
		surface: palette.white,
		surfaceMuted: "#FBF9F4",
		surfaceSunken: "#EFEBE2",
		text: palette.ink,
		textSecondary: "#3E5058",
		textMuted: "#5B6A70",
		textInverse: palette.ivory,
		border: "#E3DDD1",
		borderInput: "#928B80",
		focus: palette.ink,
		primary: palette.ink,
		primaryHover: "#24363D",
		onPrimary: palette.white,
		accent: palette.coral,
		accentStrong: palette.coralStrong,
		onAccentStrong: palette.white,
		accentSubtle: "#FDF0EC",
		link: palette.rust,
		danger: palette.rust,
		dangerSubtle: "#FBEDEA",
		onDanger: palette.white,
		success: palette.sage,
		successSubtle: "#E8F3EC",
		warning: palette.amber,
		warningSubtle: "#FBF3E2",
		info: "#34474F",
		infoSubtle: "#EEF1F2",
		laneInternal: "#FBF3E2",
		laneInternalBorder: palette.amber,
		laneAgentWork: "#EEF1F2",
		laneAgentWorkBorder: "#4A5B62",
		overlay: "rgba(25, 42, 48, 0.48)"
	},
	dark: {
		bg: "#0F1A1E",
		surface: "#16242A",
		surfaceMuted: "#1B2C33",
		surfaceSunken: "#0B1417",
		text: "#F2EFE8",
		textSecondary: "#C9D1D4",
		textMuted: "#9AA7AC",
		textInverse: palette.ink,
		border: "#2A3B42",
		borderInput: "#6B7E86",
		focus: palette.ivory,
		primary: palette.ivory,
		primaryHover: "#E7E2D6",
		onPrimary: palette.ink,
		accent: palette.coral,
		accentStrong: "#F07A62",
		onAccentStrong: palette.ink,
		accentSubtle: "#3A221C",
		link: "#F29A87",
		danger: "#F08C7A",
		dangerSubtle: "#3A1F1B",
		onDanger: palette.ink,
		success: "#6CC495",
		successSubtle: "#13301F",
		warning: "#E3B55A",
		warningSubtle: "#33270F",
		info: "#B7C4C9",
		infoSubtle: "#1F3139",
		laneInternal: "#33270F",
		laneInternalBorder: "#E3B55A",
		laneAgentWork: "#1F3139",
		laneAgentWorkBorder: "#9AA7AC",
		overlay: "rgba(5, 10, 12, 0.64)"
	}
};
/**
* Colour pairs the UI actually renders, with the contrast they must meet. Tests assert each one,
* so adding a role without a checked pairing is caught in review.
*/
const contrastPairs = [
	{
		fg: "text",
		bg: "bg",
		use: "text"
	},
	{
		fg: "text",
		bg: "surface",
		use: "text"
	},
	{
		fg: "text",
		bg: "surfaceMuted",
		use: "text"
	},
	{
		fg: "text",
		bg: "surfaceSunken",
		use: "text"
	},
	{
		fg: "textSecondary",
		bg: "surface",
		use: "text"
	},
	{
		fg: "textSecondary",
		bg: "bg",
		use: "text"
	},
	{
		fg: "textMuted",
		bg: "surface",
		use: "text"
	},
	{
		fg: "textMuted",
		bg: "bg",
		use: "text"
	},
	{
		fg: "textMuted",
		bg: "surfaceMuted",
		use: "text"
	},
	{
		fg: "onPrimary",
		bg: "primary",
		use: "text"
	},
	{
		fg: "onPrimary",
		bg: "primaryHover",
		use: "text"
	},
	{
		fg: "onAccentStrong",
		bg: "accentStrong",
		use: "text"
	},
	{
		fg: "onDanger",
		bg: "danger",
		use: "text"
	},
	{
		fg: "link",
		bg: "surface",
		use: "text"
	},
	{
		fg: "link",
		bg: "bg",
		use: "text"
	},
	{
		fg: "danger",
		bg: "surface",
		use: "text"
	},
	{
		fg: "danger",
		bg: "dangerSubtle",
		use: "text"
	},
	{
		fg: "success",
		bg: "surface",
		use: "text"
	},
	{
		fg: "success",
		bg: "successSubtle",
		use: "text"
	},
	{
		fg: "warning",
		bg: "surface",
		use: "text"
	},
	{
		fg: "warning",
		bg: "warningSubtle",
		use: "text"
	},
	{
		fg: "info",
		bg: "infoSubtle",
		use: "text"
	},
	{
		fg: "text",
		bg: "laneInternal",
		use: "text"
	},
	{
		fg: "text",
		bg: "laneAgentWork",
		use: "text"
	},
	{
		fg: "text",
		bg: "accentSubtle",
		use: "text"
	},
	{
		fg: "borderInput",
		bg: "surface",
		use: "ui"
	},
	{
		fg: "borderInput",
		bg: "bg",
		use: "ui"
	},
	{
		fg: "focus",
		bg: "surface",
		use: "ui"
	},
	{
		fg: "focus",
		bg: "bg",
		use: "ui"
	},
	{
		fg: "accent",
		bg: "surface",
		use: "ui"
	},
	{
		fg: "laneInternalBorder",
		bg: "surface",
		use: "ui"
	},
	{
		fg: "laneAgentWorkBorder",
		bg: "surface",
		use: "ui"
	}
];
const typography = {
	fontSans: "'DM Sans Variable', 'DM Sans', 'Noto Sans Arabic', 'Noto Sans Devanagari', system-ui, -apple-system, 'Segoe UI', sans-serif",
	/** Urdu reads best in Nastaliq; Arabic-script fallback keeps glyph coverage. */
	fontUrdu: "'Noto Nastaliq Urdu', 'Noto Sans Arabic', 'DM Sans Variable', serif",
	fontMono: "ui-monospace, 'SFMono-Regular', 'Cascadia Code', Menlo, Consolas, monospace",
	/** rem-based so browser text enlargement scales the UI (WCAG 1.4.4). */
	size: {
		xs: ["0.75rem", "1rem"],
		sm: ["0.8125rem", "1.25rem"],
		base: ["0.875rem", "1.375rem"],
		md: ["1rem", "1.5rem"],
		lg: ["1.125rem", "1.625rem"],
		xl: ["1.25rem", "1.75rem"],
		"2xl": ["1.5rem", "2rem"],
		"3xl": ["1.75rem", "2.25rem"]
	},
	weight: {
		regular: 400,
		medium: 500,
		semibold: 600,
		bold: 700
	}
};
/** Spacing scale in px (4, 8, 12, 16, 24, 32) — Tailwind's 0.25rem base produces these steps. */
const spacing = [
	4,
	8,
	12,
	16,
	24,
	32
];
const radius = {
	sm: "6px",
	/** Inputs. */
	md: "8px",
	/** Menus and dialogs. */
	lg: "12px",
	/** Customer widget container. */
	xl: "16px",
	full: "9999px"
};
const controlHeight = {
	/** Desktop minimum nominal height. */
	desktop: "40px",
	/** Touch target goal. */
	touch: "44px"
};
const motion = {
	fast: "120ms",
	base: "160ms",
	slow: "180ms",
	easing: "cubic-bezier(0.2, 0, 0, 1)"
};
const shadow = {
	sm: "0 1px 2px rgba(25, 42, 48, 0.06)",
	md: "0 4px 16px rgba(25, 42, 48, 0.10)",
	lg: "0 16px 48px rgba(25, 42, 48, 0.18)"
};
const zIndex = {
	dropdown: 40,
	sticky: 50,
	drawer: 60,
	dialog: 70,
	toast: 80,
	tooltip: 90
};
/** Layout frames from the design kit (used by e2e tests and previews). */
const frames = {
	agentWorkspace: {
		width: 1440,
		height: 1e3
	},
	admin: {
		width: 1440,
		height: 1e3
	},
	widget: {
		width: 390,
		height: 620
	},
	mobile: {
		width: 390,
		height: 844
	},
	desktopCanonical: {
		width: 1440,
		height: 1024
	},
	checkWidths: [
		320,
		360,
		390,
		768,
		1024,
		1440,
		1920
	]
};
//#endregion
export { AA_THRESHOLD, bestOn, brandAssets, colors, contrastPairs, contrastRatio, controlHeight, formatRatio, frames, isHexColor, markGeometry, meetsAA, motion, palette, parseHex, productVisuals, radius, relativeLuminance, shadow, spacing, typography, validateTheme, zIndex };

//# sourceMappingURL=index.js.map